import styled, { css } from 'styled-components';

interface IProps {
  type?: 'left' | 'right';
}

export const TooltipBox = styled.div<IProps>`
  position: relative;
  top: 1.5px;
  display: inline-block;
  margin-left: 4px;

  .question-mark {
    cursor: pointer;

    & > svg {
      display: block !important;
      width: 16px !important;
      height: 16px !important;
      margin-left: 0 !important;

      path {
        fill: #333;
      }
    }
  }

  .tooltip-item {
    top: 27px;
  }

  ${props => {
    switch (props.type) {
      case 'left':
        return css`
          .tooltip-item {
            left: -29px;
          }
        `;
      case 'right':
        return css`
          .tooltip-item {
            right: -28px;
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.pc} {
    top: -0.5px;

    .question-mark {
      & > svg {
        width: 18px !important;
        height: 18px !important;
      }
    }

    .tooltip-item {
      top: 29px;

      .text {
        font-size: 13px;
      }
    }
  }
`;
